<div class="wrap-main-home">
  <div *ngIf="FilterPhoto.length >0">
    <div class="video-section">
      <div class="title-header">
        <h1 style="padding-top: 30px">Photo Gallery</h1>
      </div>

      <div class="ui-g">
        <div
          *ngFor="let data of FilterPhoto"
          class="ui-g-4 ui-lg-4 ui-md-6 ui-sm-12"
        >
          <div
            class="image-card"
            [style.backgroundImage]="'url(' + data?.link + ')'"
          ></div>
        </div>
      </div>
    </div>
  </div>
</div>
